"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketClient = void 0;
const socket_io_client_1 = __importDefault(require("socket.io-client"));
class SocketClient {
    constructor(props) {
        this.socket = socket_io_client_1.default(props.uri || 'http://localhost:4000');
    }
    sendEpoch(id, epoch) {
        const { data, info, packetLoss } = epoch;
        const samples = data.map((D, i) => ({
            channel: i,
            data: D.map((d) => (d ? d : 0)),
        }));
        this.socket.emit('muse-epoch', Object.assign({ id, samples, packetLoss }, info));
    }
    sendTele(id, data) {
        this.socket.emit('muse-tele', {
            id,
            data,
            timestamp: new Date().getTime(),
        });
    }
    sendAccel(id, epoch) {
        const { data, info, packetLoss } = epoch;
        const samples = data.map((D, i) => ({
            channel: i,
            data: D.map((d) => (d ? d : 0)),
        }));
        this.socket.emit('muse-accel', Object.assign({ id, samples, packetLoss }, info));
    }
    sendGyro(id, epoch) {
        const { data, info, packetLoss } = epoch;
        const samples = data.map((D, i) => ({
            channel: i,
            data: D.map((d) => (d ? d : 0)),
        }));
        this.socket.emit('muse-gyro', Object.assign({ id, samples, packetLoss }, info));
    }
    sendPPG(id, epoch) {
        const { data, info, packetLoss } = epoch;
        const samples = data.map((D, i) => ({
            channel: i,
            data: D.map((d) => (d ? d : 0)),
        }));
        this.socket.emit('muse-ppg', Object.assign({ id, samples, packetLoss }, info));
    }
    sendEvent(id, event) {
        this.socket.emit('event', Object.assign({ id }, event));
    }
}
exports.SocketClient = SocketClient;
//# sourceMappingURL=socket.js.map